let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ctZCD"), load("5NFhD")]).then(() => parcelRequire('011Nq'));